import { FC } from 'react';

import Rate from 'components/rate/Rate';
import OverviewRateRow from './overviewRateRow/OverviewRateRow';
import { IReviewOverview } from 'types';
import './reviewsOverview.scss';
import ReviewInformation from './rate/ReviewInformation';

const ReviewOverview: FC<IReviewOverview> = ({ totalReviews, avg, totalRates }) => {
  const rateValues = totalRates.map((item) => item.value);

  const max = Math.max(...rateValues);

  const renderRows = () => {
    return totalRates.map((item) => (
      <OverviewRateRow key={item.type} maxTotalCount={max} value={item.value} type={item.type} />
    ));
  };

  return (
    <div className="reviews-overview">
      <ReviewInformation avg={avg} totalReviews={totalReviews} />
      <Rate value={avg} totalReviews={totalReviews} shouldDisplayReviews />
      {renderRows()}
    </div>
  );
};

export default ReviewOverview;
